import axios from 'axios'

const BASE_URL = process.env.VUE_APP_BASE_URL

const token = sessionStorage.getItem('token')
axios.defaults.headers.common.Authorization = `Bearer ${token}`

async function getAll() {
  try {
    return await axios.get(`${BASE_URL}customer`)
  } catch ({ response }) {
    return response
  }
}

async function getClient(id) {
  try {
    return await axios.get(`${BASE_URL}customer/${id}`)
  } catch ({ response }) {
    return response
  }
}

async function newClient(data) {
  try {
    return await axios.post(`${BASE_URL}customer`, data)
  } catch ({ response }) {
    return response
  }
}

async function updateClient(id, data) {
  try {
    return await axios.put(`${BASE_URL}customer/${id}`, data)
  } catch ({ response }) {
    return response
  }
}

export {
  getAll,
  getClient,
  newClient,
  updateClient,
}
